import { LightMode } from '@chakra-ui/react';
import React from 'react';
import { Handle, NodeProps, Position } from 'reactflow';

import { useNode } from '../hooks/bbplMonitorContext';
import { SIZES } from './consts';
import { NodeDisplay } from './NodeDisplay';

export const NodeWithHandles = (props: NodeProps<string>) => {
  const { data } = props;
  const node = useNode(data);
  if (!node) return null;

  const style = {
    width: SIZES.nodeHandleWidth,
    height: SIZES.nodeHandleHeight,
  };
  return (
    <>
      {node.hasInputs && (
        <Handle type="target" position={Position.Left} style={style} />
      )}
      <LightMode>
        <NodeDisplay node={node} />
      </LightMode>
      {node.hasOutputs && (
        <Handle type="source" position={Position.Right} style={style} />
      )}
    </>
  );
};
